import clsx from 'clsx';
import React from 'react';

import { DateRangeFilterOption } from './FilterBox';

import Checkbox from '../../Checkbox/Checkbox';
import DateRange from '../DateRange/DateRange';
import Sort from '../Sort/V2/Sort';

const DateRangeFilterBox = (props) => {
  const {
    column,
    filterOption,
    classes = {},
    sortingType,
    onUpdateSorting,
    onUpdateFilters,
    disableFilters,
    hideFilterSection,
    selectAllLabel,
    isAsc,
    isDesc,
  } = props;

  const filter = {
    id: filterOption.id,
  };
  const isAllOptionVisible = true;

  const isCheckedAll = filterOption && !filterOption.isActive;

  const handleSelectAll = () => {
    onUpdateFilters({
      ...filterOption,
      isActive: false,
    });
  };

  const handleSelectFilter = () => {
    onUpdateFilters({
      ...filterOption,
      isActive: !filterOption.isActive,
    });
  };

  const handleUpdateFilters = (filterOptions: DateRangeFilterOption[]) => {
    const filterOptionValue = filterOptions[0].value;
    onUpdateFilters({
      value: {
        from: filterOptionValue.from,
        to: filterOptionValue.to,
      },
    });
  };

  return (
    <div className={clsx(`filterBoxContainer`, classes.options)}>
      {column.sorting && (
        <Sort
          isAsc={isAsc}
          isDesc={isDesc}
          sortingType={sortingType}
          onUpdateSorting={onUpdateSorting}
        />
      )}
      {!hideFilterSection && (
        <div className={clsx(`filterByContainer`, 'dateRangeBoxContainer', classes.filterBy)}>
          <h4>Filter By</h4>
          <div className="filterItems">
            {isAllOptionVisible && (
              <div className={clsx(`filterItem`, disableFilters && 'disabled')}>
                <div className="filterCheckbox">
                  <Checkbox value="all" onChange={handleSelectAll} checked={isCheckedAll} />
                  <span>{selectAllLabel ? selectAllLabel : 'All'}</span>
                </div>
              </div>
            )}

            <div key={`dateRangeFilterKey`} className="filterItem">
              <DateRange
                filter={filter}
                filterSelected={[filterOption]}
                onUpdate={handleUpdateFilters}
                onSelect={handleSelectFilter}
                isChecked={!filterOption.isActive}
              />
            </div>
          </div>
        </div>
      )}
      {/* <div className="bottomContent">{bottomContent}</div> */}
    </div>
  );
};

export { DateRangeFilterBox };
